import { useMutation, useQueryClient } from '@tanstack/react-query';
import toast from 'react-hot-toast';
import { addCredit, voidCredit } from '../requests/credit.request';
import { AddCreditRequest } from '../types/credit.types';

export const useAddCreditMutation = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: async (request: AddCreditRequest) => await addCredit(request),
    onSuccess: (data) => {
      queryClient.invalidateQueries(['client-credit-summary', data.creditId]);
      queryClient.invalidateQueries(['customers-with-credit-balance']);
      toast.success(
        `Added $${data.amount.toFixed(2)} credit. New balance: $${data.newAvailableBalance.toFixed(
          2
        )}`
      );
    },
    onError: () => {
      toast.error('Failed to add credit');
    }
  });
};

export const useVoidCreditMutation = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: async (creditId: string) => await voidCredit(creditId),
    onSuccess: (data) => {
      queryClient.invalidateQueries(['client-credit-summary']);
      queryClient.invalidateQueries(['customers-with-credit-balance']);
      toast.success(`Voided $${data.amountVoided.toFixed(2)} credit`);
    },
    onError: () => {
      toast.error('Failed to void credit');
    }
  });
};
